var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groupList"},_vm._l((_vm.groupList),function(item,index){return _c('div',{key:index,staticClass:"group-item",on:{"click":function($event){return _vm.seeDetail(item)}}},[_c('img',{attrs:{"src":item.userFaceUrl,"alt":""}}),_c('p',{staticClass:"name"},[_vm._v(_vm._s(item.userName))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }